import cwc from '../../Images/Home/cwc.png';  
import CocaCola from '../../Images/Home/CocaCola.png';  
import NSIC from '../../Images/Home/NSIC.png';  
import ncert from '../../Images/Home/ncert.png';
import qatar_fuel from '../../Images/Home/qatar_fuel.png';


const Content =[
    {
        id:1,
        image: cwc,
        alt:"cwc",
        title:"CWC",
        text:"End-to-End digitalization of accounting processes and systems, integration with disparate systems  delievring substatial benefits e.g. 50% reduction in receivables,  finalization of annual accounts in 45 days, centralized view of business at the click of the button."
        
    },
    {
        id:2,
        image: CocaCola,
        alt:"cocacola",
        title:"Cocacola",
        text:"Managed services for bottling operations across multiple countries"
        
    },
    {
        id:3,
        image:qatar_fuel,
        alt:"Qatar Fuel",
        title:"Qatar Fuel",
        text:"Defining Corporate Service Management Policies, Processes and Procedures alongwith design of Service Management System for customers, employees and partners."
        
    },
    {
        id:4,
        image: ncert,
        alt:"NCERT",
        title:"NCERT",
        text:"Implementation of Financial accounting system across various divisions and institutes resulting in centralized view of funds utilization and compliance to Ministry requirements."
        
    },
  
];
export default Content;